// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type IsInvoiceDeletableQueryVariables = Types.Exact<{
  invoiceId: Types.Scalars['Int']['input'];
}>;


export type IsInvoiceDeletableQueryResult = { __typename?: 'Query', isInvoiceDeletable: boolean };

export const IsInvoiceDeletableGql = gql`
    query IsInvoiceDeletable($invoiceId: Int!) {
  isInvoiceDeletable(invoiceId: $invoiceId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class IsInvoiceDeletableInjectable extends Apollo.Query<IsInvoiceDeletableQueryResult, IsInvoiceDeletableQueryVariables> {
    override document = IsInvoiceDeletableGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */